import React from 'react';
import { DragDropContext, Droppable, DropResult } from 'react-beautiful-dnd';
import { GqlImageBanner } from 'types/graphql';
import useHasMobileApp from 'src/utils/use-has-mobile-app';

import { ImageBannerListItem } from './image-banner-list-item';

type ImageBannerListProps = {
  imageBanners: GqlImageBanner[];
  removeBanner: (index: number) => void;
  editBanner: (id: string) => void;
  onDragEnd: (result: DropResult) => void;
};

export function ImageBannerList({
  imageBanners,
  removeBanner,
  editBanner,
  onDragEnd,
}: ImageBannerListProps): JSX.Element {
  const hasMobileApp = useHasMobileApp();

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId='slider-banners' type='slider-banner'>
        {(provided) => (
          <div {...provided.droppableProps} ref={provided.innerRef} style={{ width: '100%' }}>
            {imageBanners.map((banner, index) => (
              <ImageBannerListItem
                banner={banner}
                hasMobileApp={hasMobileApp}
                index={index}
                key={banner._id}
                onRemove={removeBanner}
                onEdit={editBanner}
                isActive={banner.isActive ?? true}
              />
            ))}

            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
}
